import React, { useEffect, useState } from 'react'
import Loader from 'components/D3Loader'
import Announcement from './Announcement'

import { noAnnouncementsHumi } from '../../../assets/assets'

const AnnouncementsList = ({
  loading,
  announcements,
  strings,
  unreadAnnouncements,
  onAnnouncementRead,
  sendEvent,
  sendAnnouncementsSeen,
  humiIsabellaDisabled
}) => {
  const [openId, setOpenId] = useState(null)

  useEffect(() => {
    if (announcements.length) {
      sendAnnouncementsSeen(announcements)
    }
  }, [])

  const onToggleAnnouncement = announcement => {
    const opening = openId !== announcement.id
    setOpenId(opening ? announcement.id : null)
    if (opening) {
      onAnnouncementRead(announcement.id, announcement.instrumentID)
    }
  }
  return (
    <div className='announcements-list'>
      {loading && <Loader inContainer />}
      {!loading &&
        (announcements.length > 0 ? (
          announcements.map(announcement => (
            <Announcement
              key={announcement.id}
              announcement={announcement}
              unreadAnnouncements={unreadAnnouncements}
              onAnnouncementRead={onAnnouncementRead}
              sendEvent={sendEvent}
              strings={strings}
              isOpen={openId === announcement.id}
              onToggle={() => onToggleAnnouncement(announcement)}
            />
          ))
        ) : (
          <div className='no-announcements'>
            {!humiIsabellaDisabled ? (
              <img src={noAnnouncementsHumi} alt='no-announcements-humi' />
            ) : null}
            <p>{strings.no_announcements1}</p>
            <p>{strings.no_announcements2}</p>
          </div>
        ))}
    </div>
  )
}

export default AnnouncementsList